export function isVertesiaEmail(email) {
    return email ? (email.endsWith('@vertesiahq.com') ||
        email.endsWith('@becomposable.com') ||
        email.endsWith('@composableprompts.com')) : false;
}
//# sourceMappingURL=utils.js.map